/** 页面信息 */
const page = new (function () {
  this.title = '环保法配套办法执行情况区域分布表'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_statistic_ptbffb'
  /**菜单编号 */
  this.code = 'penalize_statistic_ptbffb'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/statistic/ptbffb'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
